import React, { Component } from 'react';
import { Data } from './Data';

export class TestConn extends Component {
  constructor(props) {
    super(props);
    this.dataService = new Data();
    this.state = { testData: '' };
    this.dataService.getDummyDataItem(1).then((data) => { this.setState({ testData: JSON.stringify(data) }); });
  }

  render() {
    return (
      <div>
        {this.state.testData}
      </div>
    );
  }
}
